import { createUiIdContext } from '../../../contexts/ElementIdContext';

const elementIds = {
  btnViewLinked: 'btnViewLinked',
  divOutletList: 'divOutletList',
  divOutletForm: 'divOutletForm',
};

export const { ElementIdProvider, useElementIdContext } =
  createUiIdContext(elementIds);
